import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SunIcon from "assets/svgIcons/SunIcon";
import AddIcon from "assets/svgIcons/AddIconWithCircle";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import EditIcon from "assets/svgIcons/EditIcon";
import { CircleBtn } from "assets/css/globle";
import {
  getFeatureSetOption,
  getFeaturesList,
  isUserBasic,
  isUserReadOnly,
  featureKey
} from "../../../constant";
import { useTranslation } from "react-i18next";
import {
  Container,
  Header,
  BodyWrapper,
  Heading,
  HeaderBtn,
  BoxWrapper,
  DataBox,
  ActionBtn,
} from "pages/Pins/RotationSetup/RotationSetupStyled";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { uuid } from "_helperFunctions/uuid";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { PopUpContainer } from "assets/css/globle";
import _ from "lodash";
import moment from "moment";
import { Button, IconButton, Tooltip } from "@mui/material";
import { GlobalCourseIdState } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { Loader } from "commonComponents/Loader/Loader";
import { API_STATUSES } from "redux/_helpers/statuses";
import { DailyRotationDays } from "../DailyRotationDays";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "400px",
  width: "calc(100% -  40px)",
  bgcolor: "background.paper",
  borderRadius: "5px",
  overflow: "hidden",
};

export const RotationSetup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { globalCourseId } = useHookstate(GlobalCourseIdState);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { t } = useTranslation();
  const {
    getRotationStateData,
    siteSettingsData,
    getUserRole,
    greensWithPinPlacementStateData,
  } = useSelector((state) => state.commonReducers) || [];

  const [oneDayOverride, setOneDayOverride] = useState(false);
  let greensWithPinPlacementStateDataa = [];
  const [open, setOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [EditData, setEditData] = useState(null);
  const [showErrorMsg, setErrorMsg] = useState(false);
  const [waringMsg, setWaringMsg] = useState(false);
  const [EventNameWaringMsg, setEventNameWaringMsg] = useState(false);
  const [sucessMsg, setSucessMsg] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState(false);
  const [addOpenOneDay, setAddOpenOneDay] = useState(false);
  const [removeOpenOneDay, setRemoveOpenOneDay] = useState(false);
  const [addSpecialEvent, setAddSpecialEvent] = useState("");
  const [greensDescriptionsState, setGreensDescriptionsState] = useState(null);
  const [courseId, setCourseId] = useState("");
  const [activeButton, setActiveButton] = useState(false);
  const [activeButton1, setActiveButton1] = useState(false);
  const updateOneDayOverrideState = (value) => {
    setOneDayOverride(value);
  };

  const updateAddOpenOneDayState = (value) => {
    setAddOpenOneDay(value);
  };

  const updateRemoveOpenOneDayState = (value) => {
    setRemoveOpenOneDay(value);
  };

  useEffect(() => {
      if(Object.keys(siteSettingsData).length > 0) {
        if(siteSettingsData?.Features?.indexOf(featureKey.golf) <= 0) {
          navigate("/dashboard", { replace: true });
        }
      }
      }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    if (
      greensDescriptionsState &&
      Object.keys(greensDescriptionsState).length > 0
    ) {
      updateOneDayOverrideState(greensDescriptionsState?.IsOneDayOverride);
    }
  }, [greensDescriptionsState]);

  const handleAddOpen = () => {
    setActiveButton(true);
    if (
      greensDescriptionsState &&
      greensDescriptionsState !== undefined &&
      greensDescriptionsState?.RotationSets?.length !== 0
    ) {
      var compareList = greensDescriptionsState?.RotationSets.map(
        (item) => item.Type === "Special" && item.UserFigure
      );
      var found = false;
      var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
      _.each(alphabet, function (letter) {
        if (!found && !_.includes(compareList, letter)) {
          setMissingMarker(letter);
          setAddPinMarker(letter);
          found = true;
        }
      });

      setAddOpen(true);
    } else {
      setMissingMarker("A");
      setAddPinMarker("A");
      setAddOpen(true);
    }
  };
  useEffect(() => {
    setCourseId(globalCourseId.get());
  }, [globalCourseId.get()]);

  const handleClose = () => {
    setEditSpecialEvent("");
    setEditPinMarker("");
    setWaringMsg(false);
    setEventNameWaringMsg(false);
    setErrorMsg(false);
    setOpen(false);
  };
  const [disableState, setDisableState] = useState(true);
  const [editDisableState, setEditDisableState] = useState(false);
  const [updateDom, setUpdatedDom] = useState(false);
  const [MissingMarker, setMissingMarker] = useState("");
  const [addPinMarker, setAddPinMarker] = useState("");
  const [editSpecialEvent, setEditSpecialEvent] = useState("");
  const [editPinMarker, setEditPinMarker] = useState("");
  const [logActionsState, setLogActionsState] = useState([]);
  const { siteSettingDataReduxStateStatus } = useSelector((state) => state.commonReducers) || [];

  let greensDescriptions = {};

  useEffect(() => {
    dispatch(
      COMMON_SERVICES.getRotationDataServices(
        siteId.get(),
        globalCourseId.get()
      )
    );
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    dispatch(COMMON_SERVICES.getCarPinPlacementsServices(siteId.get()));
  }, [siteId.get(), globalCourseId.get()]);

  useEffect(() => {
    setGreensDescriptionsState(
      JSON.parse(JSON.stringify(getRotationStateData))
    );
  }, [getRotationStateData]);

  const handleAddClose = () => {
    setAddSpecialEvent("");
    setAddPinMarker(MissingMarker);
    setWaringMsg(false);
    setErrorMsg(false);
    setEventNameWaringMsg(false);
    setAddOpen(false);
  };
  // greensDescriptions = getRotationStateData && { ...getRotationStateData };
  greensDescriptions =
    getRotationStateData && JSON.parse(JSON.stringify(getRotationStateData));

  let rotationSetType = {
    Unknown: { value: 0, name: "Unknown" },
    Daily: { value: 1, name: "Daily" },
    Special: { value: 2, name: "Special" },
  };

  let rotationType = {
    Regular: { value: 1, name: "Regular" },
    TodayOnly: { value: 2, name: "TodayOnly" },
  };

  let usageType = {
    Unknown: { value: 0, name: "Unknown" },
    Regular: { value: 1, name: "Regular" },
    TodayOnly: { value: 2, name: "TodayOnly" },
  };

  function dailyRotations() {
    // DO NOT REMOVE the statement below.  This dummy observable is being used to force this computed function to re-execute.  Nothing will be logged.
    // if (notifyActiveRotationChanged())

    if (greensDescriptions && greensDescriptions?.RotationSets?.length === 0)
      return [];

    const daily = _.flatten(
      _.filter(greensDescriptions?.RotationSets, { Type: "Daily" }),
      "Rotations"
    );
    return _.sortBy(daily, function (val) {
      return parseInt(val.Marker, 10);
    });
  }

  function logAction(action) {
    if (
      logActionsState.length > 0 &&
      logActionsState[logActionsState.length - 1] === action
    ) {
      // We aren't logging the same message repeatedly.
      return;
    }
    setLogActionsState(action);
    // logActions.push(action);
  }

  function createRotationPinPlacements(gd, rotationSet, rotation, name) {
    var aRotation = {};
    aRotation.RotationNumber = rotation.RotationNumber;
    aRotation.RotationType = rotation.RotationType;
    aRotation.PinPlacements = [];

    for (let k = 0; k < gd.ApproachViews.length; k++) {
      (function (index) {
        var approachView = gd.ApproachViews[index];
        if (approachView.PinPlacements.length > 0) {
          _(_.filter(approachView.PinPlacements, { Name: name })).forEach(
            function (pinPlacement) {
              let placement = {};
              placement.Usage =
                rotation.RotationType === rotationType.TodayOnly.value
                  ? usageType.TodayOnly.value
                  : usageType.Regular.value;
              placement.DateCreatedInUtc =
                pinPlacement.X > 0 && pinPlacement.Y > 0
                  ? moment.utc()
                  : moment(0);
              placement.Hole = approachView.Hole;
              placement.Latitude = pinPlacement.Latitude;
              placement.Longitude = pinPlacement.Longitude;
              placement.X = Math.round(pinPlacement.X);
              placement.Y = Math.round(pinPlacement.Y);
              aRotation.PinPlacements.push(placement);
            }
          );
        }
      })(k);
    }
    if (rotation.RotationType === rotationType.TodayOnly.value) {
      rotationSet.TodayRotation = aRotation;
    } else {
      rotationSet.Rotations.push(aRotation);
    }
  }

  function createTodayRotation(gd,crs, rotationSet) {
    var oneDayRotation = null;
    // We will only create the one day rotation if oneDayOverride is true and we are currently
    // creation the daily rotation set.
    if (
      crs.IsOneDayOverride &&
      rotationSet.RotationSetType === rotationSetType.Daily.value
    ) {
      oneDayRotation = {};
      oneDayRotation.RotationNumber = 1;
      oneDayRotation.RotationType = rotationType.TodayOnly.value;
      createRotationPinPlacements(gd, rotationSet, oneDayRotation, "*");
    }
  }

  function createRotationSets(gd, crs, rotationSetTypeName) {
    _(_.filter(gd?.RotationSets, { Type: rotationSetTypeName })).forEach(
      function (rotationSet) {
        var rs = {};
        rs.Course = gd.Course;
        // TODO: This needs to be kept track of at each change of a Daily Play Rotation
        rs.CurrentRotation = rotationSet.CurrentRotation;
        //rs.FirstHole = datacontext.siteSettings.Courses[0].FirstHole;
        //rs.LastHole = rs.FirstHole + datacontext.siteSettings.Courses[0].HoleCount - 1;
        rs.FirstHole = rotationSet.FirstHole;
        rs.IsActive = rotationSet.ActiveSet;
        rs.LastHole = rotationSet.LastHole;
        rs.Name = rotationSet.Name;

        rs.RotationSetType = rotationSet.RotationSetType;
        rs.PinCharacter = rotationSet.UserFigure;
        createTodayRotation(gd,crs, rs);
        rs.Rotations = [];
        for (var j = 0; j < rotationSet.Rotations.length; j++) {
          (function (rotationIndex) {
            var rotation = rotationSet.Rotations[rotationIndex];
            createRotationPinPlacements(
              gd,
              rs,
              rotation,
              rotationSet.RotationSetType === rotationSetType.Daily.value
                ? rotation.RotationNumber.toString()
                : rotationSet.UserFigure
            );
          })(j);
        }

        crs.RotationSets.push(rs);
      }
    );
  }

  function createCourseRotationSets() {
    let crs = {};
    // let gd = greensDescriptionsState !== null ? greensDescriptionsState : null;
    let gd = greensDescriptionsState;
    crs.Version = gd?.Version;
    crs.Course = gd?.Course;
    crs.IsOneDayOverride = oneDayOverride;
    crs.RotationSets = [];

    createRotationSets(gd, crs, rotationSetType.Daily.name);
    createRotationSets(gd, crs, rotationSetType.Special.name);
    return crs;
  }

  function createCourseRotationSetsOnAdd(data) {
    let crs = {};
    let gd = data;
    crs.Version = gd?.Version;
    crs.Course = gd?.Course;
    crs.IsOneDayOverride = true;
    crs.RotationSets = [];

    createRotationSets(gd, crs, rotationSetType.Daily.name);
    createRotationSets(gd, crs, rotationSetType.Special.name);
    return crs;
  }
  function createCourseRotationSetsOnRemove() {
    let crs = {};
    let gd = greensDescriptionsState;
    crs.Version = gd?.Version;
    crs.Course = gd?.Course;
    crs.IsOneDayOverride = false;
    crs.RotationSets = [];

    createRotationSets(gd, crs, rotationSetType.Daily.name);
    createRotationSets(gd, crs, rotationSetType.Special.name);
    return crs;
  }

  function renameRotationSet(selected, data) {
    // placement.dirtyEditPinsFlag(true);

    // Find both the parent and child pieces of the rotation set.
    var rotationset = null;
    for (let i = 0; i < greensDescriptionsState.RotationSets.length; i++) {
      for (
        let j = 0;
        j < greensDescriptionsState.RotationSets[i].Rotations.length;
        j++
      ) {
        if (
          greensDescriptionsState.RotationSets[i].Rotations[j].Marker ===
          selected.Marker
        ) {
          rotationset = greensDescriptionsState.RotationSets[i];
        }
      }
    }

    // Update base data
    let edit = _.filter(
      _.flatten(greensDescriptionsState.RotationSets, "Rotations"),
      { Marker: selected.Marker }
    )[0];
    let replace = JSON.parse(JSON.stringify(edit));
    if (rotationset.Type !== "Daily") {
      rotationset.UserFigure = data.Marker;
      rotationset.Name = data.DisplayName;
    }

    // Removing and replacing with the new object fixed the display issue.
    _.remove(rotationset.Rotations, edit);
    // $.extend(replace, data);
    rotationset.Rotations.push(replace);

    if (data.Marker !== selected.Marker) {
      //  Update the pins markers in the ApproachViews
      _.forEach(greensDescriptionsState.ApproachViews, function (hole) {
        _.forEach(
          _.filter(hole.PinPlacements, { Name: selected.Marker }),
          function (pp) {
            pp.Name = data.Marker;
          }
        );
      });
    }

    // placement.greensDescriptions.valueHasMutated();
    return replace;
  }

  const discardFunc = () => {
    dispatch(COMMON_SERVICES.getRotationDataServices(siteId.get(), courseId));
    setConfirmMsg(false);
    setActiveButton(false);
  };
  const addOneDayOr = () => {
    // setActiveButton(true);
    updateOneDayOverrideState(true);
    updateAddOpenOneDayState(false);
    var oneday = {
      Active: false,
      Marker: "*",
      Name: "One-Day Override",
      Type: "Unknown"
    };
    let data = createRotationSet2(oneday);
    data.IsOneDayOverride = true;
    setGreensDescriptionsState(data);
    let siteId = data?.Site;
    let payload = {
      SiteId: siteId,
      CourseRotationSetsDto: createCourseRotationSetsOnAdd(data),
      Log: "Add one-day override",
    };
    dispatch(COMMON_SERVICES.rotationDataServices(payload)).then(() => {
      dispatch(
        COMMON_SERVICES.getRotationDataServices(
          siteId.get(),
          globalCourseId.get()
        )
      );
    });
  };
  const removeOneDayOr = () => {
    updateOneDayOverrideState(false);
    updateRemoveOpenOneDayState(false);
    let siteId = greensDescriptionsState?.Site;
    let payload = {
      SiteId: siteId,
      CourseRotationSetsDto: createCourseRotationSetsOnRemove(),
      Log: "Remove one-day override",
    };
    let data = greensDescriptionsState;
    data.RotationSets = data?.RotationSets?.filter((el)=> el.Type !== "Unknown");
    data.IsOneDayOverride = false;
    let approachView =  data?.ApproachViews?.map((pin)=> {
     return pin.PinPlacements.filter((placement)=>{ return placement.Name !== "*";});
    });
    data.ApproachViews = approachView;
    setGreensDescriptionsState(data);
    dispatch(COMMON_SERVICES.rotationDataServices(payload)).then(() => {
      dispatch(
        COMMON_SERVICES.getRotationDataServices(
          siteId.get(),
          globalCourseId.get()
        )
      );
    });
  };

  const saveData = (e) => {
    setActiveButton(false);
    e.preventDefault();
    // createCourseRotationSets();
    let crsValue = createCourseRotationSets();
    let pinplacementData = [];
    for (
      let i = 1;
      i <= greensWithPinPlacementStateData?.ApproachViews.length;
      i++
    ) {
      let data = {
        DateCreatedInUtc: moment(0),
        Hole: i,
        Latitude: 0,
        Longitude: 0,
        Usage: 1,
        X: 0,
        Y: 0,
      };
      pinplacementData.push(data);
    }

    crsValue?.RotationSets.forEach((item) => {
      item &&
        item?.Rotations.forEach((item2) => {
          if (item2?.PinPlacements.length === 0) {
            item2?.PinPlacements.push(...pinplacementData);
          }
        });
    });
    let logValue = [...logActionsState];
    logValue.join(", ");
    let stringLog = logValue.toString();
    let siteId = greensDescriptionsState?.Site;
    dispatch(
      COMMON_SERVICES.rotationDataServices({
        CourseRotationSetsDto: crsValue,
        Log: stringLog,
        SiteId: siteId,
      })
    );
    setLogActionsState([]);
    setSucessMsg(true);
  };

  function removeRotationSet(evt, rData) {
    let daily = evt.target.name === "Daily";
    // var selected = daily ? selectedDailySet() : selectedSpecialSet();
    // Check to see if selected rotation is active.
    let rotationLength =
      dailyRotations().length !== 0 &&
      dailyRotations().map((e) => e?.Rotations.length);

    let rotationArray =
      dailyRotations().length !== 0 &&
      dailyRotations().map((e) => e?.Rotations);

    let rotationMarkerValue = rotationArray?.map((el) =>
      el.map((v) => v?.Marker)
    );

    if (rData?.Active) {
      // Can't remove active rotation.
      alert(
        "You cannot remove the active pin placement.  To delete this placement, please set the active pin placement to another pin placement or to Center of Green before deleting."
      );
    } else {
      logAction(
        daily
          ? "Remove rotation " + rData?.Marker + " of " + rotationLength[0]
          : "Remove rotation " + rData?.Marker
      );

      let crsValue = createCourseRotationSets();

      // crsValue

      let logValue = logActionsState.join(", ");
      let siteId = greensDescriptionsState?.Site;

      dispatch(
        COMMON_SERVICES.rotationDataServices(
          {
            CourseRotationSetsDto: crsValue,
            Log: logValue,
            SiteId: siteId.get(),
          },
          "deleteDailyPins"
        )
      );

      // deleteRotationSetData(rData);
      // Check to see if the numbers need to be adjusted for daily.

      if (daily) {
        for (let i = 0; i < rotationLength[0]; i++) {
          let markerNum = (i + 1).toString();
          if (rotationMarkerValue[0][i].Marker !== markerNum) {
            // if (dailyRotations[i].Marker === placement.activeMarker()) {
            //  placement.activeMarker(markerNum);
            let rotationset = _.filter(greensDescriptions.RotationSets, {
              Type: "Daily",
            });

            if (rotationset.length === 1)
              rotationset[0].CurrentRotation = markerNum;
            // }

            renameRotationSet(rotationMarkerValue[0][i], {
              DisplayName: `Daily Pin Rotation ${markerNum}`,
              Marker: markerNum,
              // FB 2885: Deleting daily rotation set doesn't change following rotation sets rotation number.  When data is refresh gap occurs.
              RotationNumber: i + 1,
            });
          }
        }
      }
      // Deselect the listbox
      // if (daily) {
      //   selectedDailySet(undefined);
      // } else {
      //   selectedSpecialSet(undefined);
      // }
    }
  }

  // function deleteRotationSetData(data) {
  //   // placement.dirtyEditPinsFlag(true);
  //   // Remove the related pins
  //   let newValue = _(
  //     greensDescriptions && greensDescriptions?.ApproachViews
  //   ).forEach(function (el) {
  //     _.remove(el.PinPlacements, function (pin) {
  //       return pin.Name === data.Marker;
  //     });
  //   });

  //   // Remove the rotation set
  //   // let rotationset = null;
  //   // let rotation = null;
  //   // outer_block: for (
  //   //   let i = 0;
  //   //   i < greensDescriptions && greensDescriptions?.RotationSets?.length;
  //   //   i++
  //   // ) {
  //   //   for (
  //   //     let j = 0;
  //   //     j < greensDescriptions &&
  //   //     greensDescriptions?.RotationSets[i]?.Rotations?.length;
  //   //     j++
  //   //   ) {
  //   //     if (
  //   //       greensDescriptions?.RotationSets[i]?.Rotations[j]?.Marker ===
  //   //       data.Marker
  //   //     ) {
  //   //       rotationset = greensDescriptions?.RotationSets[i];
  //   //       rotation = greensDescriptions?.RotationSets[i].Rotations[j];

  //   //       break outer_block;
  //   //     }
  //   //   }

  //   // }
  //   // _.remove(rotationset.Rotations, rotation);
  //   // if (rotationset.Rotations.length === 0)
  //   //   _.remove(greensDescriptions.RotationSets, rotationset);

  //   // // Trigger refresh for computed items.
  //   // placement.greensDescriptions.valueHasMutated();
  // }

  function createRotationSet(data) {
    // placement.dirtyEditPinsFlag(true);
    // Create the pins for the new set.
    // let innerCheck = _.forEach(
    //   greensDescriptions?.ApproachViews,
    //   function (approach) {
    //     return approach;
    //     // .push({
    //     //   Name: data?.Marker,
    //     //   Latitude: 0,
    //     //   Longitude: 0,
    //     //   X: 0,
    //     //   Y: 0,
    //     // });
    //   }
    // );

    // let loc = _.union(greensDescriptions?.ApproachViews, [
    //   {
    //     Name: 10,
    //     Latitude: 0,
    //     Longitude: 0,
    //     X: 0,
    //     Y: 0,
    //   },
    // ]);

    // let innerCheck = _.forEach(
    //   greensDescriptions?.ApproachViews,
    //   function (approach) {

    // _.union(approach.PinPlacements, [
    //   {
    //     Name: 10,
    //     Latitude: 0,
    //     Longitude: 0,
    //     X: 0,
    //     Y: 0,
    //   },
    // ]);
    //   }
    // );
    // .push({
    //   Name: data?.Marker,
    //   Latitude: 0,
    //   Longitude: 0,
    //   X: 0,
    //   Y: 0,
    //   }
    // );

    // loc,

    let newRotation = {
      Active: false,
      Marker: data.Marker,
      DisplayName: data.Name,
      RotationNumber: 1,
      RotationType: 1,
    };
    let newRotationSet = {
      ActiveSet: false,
      Course: greensDescriptions.Course,
      CurrentRotation: 1,
      FirstHole:
        siteSettingsData &&
        siteSettingsData.Courses[greensDescriptions.Course - 1].FirstHole,
      LastHole:
        siteSettingsData &&
        siteSettingsData.Courses[greensDescriptions.Course - 1].FirstHole +
        siteSettingsData &&
        siteSettingsData.Courses[greensDescriptions.Course - 1].HoleCount - 1,
      Name: data.Name,
      Rotations: [newRotation],
      Type: data.Type,
      RotationSetType: _.find(rotationSetType, { name: data.Type }).value,
      UserFigure: data.Marker,
    };

    if (data.Type === "Unknown") newRotation.RotationType = 2; // TodayOnly

    // // Add this new rotation to the dataset.
    if (data.Type !== "Daily") {
      // Create a rotation set for the server.  Then create the rotation as the child of the rotation set.
      greensDescriptions.RotationSets.push(newRotationSet);
    } else {
      // Check to see if there is a rotation set available.  Add if needed. Then add rotation set as child.
      if (
        greensDescriptions.RotationSets.length === 0 ||
        _.filter(greensDescriptions.RotationSets, { Type: "Daily" }).length ===
        0
      ) {
        newRotationSet.UserFigure = "?";
        newRotation.DisplayName = data.Name + " 1";
        greensDescriptions.RotationSets.push(newRotationSet);
      } else {
        // Get existing rotation set and add child.
        var daily = _.filter(greensDescriptions.RotationSets, {
          Type: "Daily",
        })[0];

        newRotation = {
          ...newRotation,
          DisplayName: data.Name + " " + (daily.Rotations.length + 1),
          RotationNumber: daily.Rotations.length + 1,
        };
      }
    }
  }

  function createRotationSet2(data) {
    // placement.dirtyEditPinsFlag(true); Uncomment this later

    // Create the pins for the new set.
    greensWithPinPlacementStateDataa = JSON.parse(
      JSON.stringify(greensDescriptionsState)
    );
    if (
      greensWithPinPlacementStateDataa &&
      Object.keys(greensWithPinPlacementStateDataa).length !== 0 &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length !== 0
    ) {
      _.forEach(
        greensWithPinPlacementStateDataa?.ApproachViews,
        function (approach) {
          approach.PinPlacements.push({
            Name: data.Marker,
            Latitude: 0,
            Longitude: 0,
            X: 0,
            Y: 0,
          });
        }
      );

      var newRotation = {
        Active: false,
        Marker: data.Marker,
        DisplayName: data.Name,
        RotationNumber: 1,
        RotationType: 1,
      };
      var newRotationSet = {
        ActiveSet: false,
        Course: greensWithPinPlacementStateDataa?.Course,
        CurrentRotation: 1,
        FirstHole:
          siteSettingsData?.Courses[
            greensWithPinPlacementStateDataa?.Course - 1
          ].FirstHole,
        LastHole:
          siteSettingsData?.Courses[
            greensWithPinPlacementStateDataa?.Course - 1
          ].FirstHole +
          siteSettingsData?.Courses[
            greensWithPinPlacementStateDataa?.Course - 1
          ].HoleCount -
          1,
        Name: data.Name,
        Rotations: [newRotation],
        Type: data.Type,
        RotationSetType: _.find(rotationSetType, { name: data.Type }).value,
        UserFigure: data.Marker,
      };

      if (data.Type === "Unknown") newRotation.RotationType = 2; // TodayOnly

      // Add this new rotation to the dataset.
      if (data.Type !== "Daily") {
        // Create a rotation set for the server.  Then create the rotation as the child of the rotation set.
        greensWithPinPlacementStateDataa?.RotationSets.push(newRotationSet);
        return greensWithPinPlacementStateDataa;
      } else {
        // Check to see if there is a rotation set available.  Add if needed. Then add rotation set as child.
        if (
          greensWithPinPlacementStateDataa?.RotationSets.length === 0 ||
          _.filter(greensWithPinPlacementStateDataa?.RotationSets, {
            Type: "Daily",
          }).length === 0
        ) {
          newRotationSet.UserFigure = "?";
          newRotation.DisplayName = data.Name + " 1";

          greensWithPinPlacementStateDataa?.RotationSets.push(newRotationSet);

          return greensWithPinPlacementStateDataa;
        } else {
          // Get existing rotation set and add child.
          var daily = _.filter(greensWithPinPlacementStateDataa?.RotationSets, {
            Type: "Daily",
          })[0];
          // $.extend(newRotation, {
          //    DisplayName: data.Name + " " + (daily.Rotations.length + 1),
          //    RotationNumber: (daily.Rotations.length + 1),
          // });
          var updateNewRotation = {
            ...newRotation,
            DisplayName: data.Name + " " + (daily.Rotations.length + 1),
            RotationNumber: daily.Rotations.length + 1,
          };

          daily.Rotations.push(updateNewRotation);

          return daily;
        }
      }

      // placement.greensDescriptions.valueHasMutated();

      // if (data.Type === "Special") {
      //    selectedSpecialSet(newRotation);
      // }
    }
  }

  const addRotationSet = (evt) => {
    evt.preventDefault();
    setActiveButton(true);
    let newRotationSet = {
      Active: false,
      Marker: "",
      RotationNumber: 0,
      RotationType: 1,
      DisplayName: "",
      // Type:evt.target.name
    };
    let tempStorage = greensDescriptionsState?.RotationSets?.filter((el)=> el.Type === "Daily");
    let rotationLength =
      tempStorage && tempStorage.length > 0
        ? tempStorage[0].Rotations.length : 0;

    // if (evt.target.name === "Daily") {
    let nextMarker1 = rotationLength + 1;
    logActionsState.push("Add daily rotation " + nextMarker1);
    var updateRotationSet = {
      Marker: nextMarker1.toString(),
      RotationNumber: nextMarker1,
      DisplayName: `Daily Pin Rotation ${nextMarker1}`,
    };
    newRotationSet = { ...newRotationSet, ...updateRotationSet };
    //  }

    if (tempStorage && tempStorage.length !== 0) {
      tempStorage[0].Rotations.push(newRotationSet);
      setGreensDescriptionsState(greensDescriptionsState);
      setUpdatedDom(!updateDom);
    } else {
      var newRotationSett = {
        Active: false,
        Marker: "",
        DisplayName: "",
        Name: "",
        Type: "Daily",
      };

      var nextMarker = rotationLength + 1;
      logActionsState.push(`Add daily rotation ${nextMarker}`);
      let updateRotationSet = {
        ...newRotationSett,
        Marker: nextMarker.toString(),
        Name: "Daily Pin Rotation",
        DisplayName: `Daily Pin Rotation ${nextMarker}`,
      };

      let data = createRotationSet2(updateRotationSet);
      setGreensDescriptionsState(data);
    }
  };

  if (
    greensDescriptionsState &&
    Object.keys(greensDescriptionsState).length !== 0
  ) {
    var filterSpecial = greensDescriptionsState?.RotationSets.map((item) => {
      if (item?.Type === "Special") {
        let getMarker = item?.Rotations.map((items) => items?.Marker);
        return getMarker;
      }
    });
    var filterSpecialPins = greensDescriptionsState?.RotationSets.map(
      (item) => {
        if (item?.Type === "Special") {
          let getMarker = item?.Rotations.map((items) =>
            items?.DisplayName.toUpperCase()
          );
          return getMarker;
        }
      }
    );
  }

  const editPinMarkerChange = (e) => {
    setActiveButton1(true);
    const re = /^[A-Za-z]+$/;
    let inputValue = e.target.value;
    let lastStr = inputValue.charAt(inputValue.length - 1);
    let checkValid = filterSpecial.filter(
      (item) => item === lastStr.toUpperCase()
    );
    if (checkValid.length !== 0) {
      setEditPinMarker(lastStr.toUpperCase());
      setWaringMsg(true);
      setErrorMsg(false);
    } else {
      setWaringMsg(false);
      if (inputValue === "" || re.test(inputValue)) {
        setErrorMsg(false);
        setEditPinMarker(lastStr.toUpperCase());
      } else {
        setEditPinMarker(lastStr.toUpperCase());
        setErrorMsg(true);
      }
    }
  };

  const addPinMarkerChange = (e) => {
    const re = /^[A-Za-z]+$/;
    let inputValue = e.target.value;
    let lastStr = inputValue.charAt(inputValue.length - 1);
    let checkValid = filterSpecial.filter(
      (item) => item === lastStr.toUpperCase()
    );
    if (checkValid.length !== 0) {
      setAddPinMarker(lastStr.toUpperCase());
      setWaringMsg(true);
      setErrorMsg(false);
    } else {
      setWaringMsg(false);
      if (inputValue === "" || re.test(inputValue)) {
        setAddPinMarker(lastStr.toUpperCase());
        setErrorMsg(false);
      } else {
        setAddPinMarker(lastStr.toUpperCase());
        setErrorMsg(true);
      }
    }
  };
  useEffect(() => {
    if (
      !showErrorMsg &&
      !waringMsg &&
      !EventNameWaringMsg &&
      addSpecialEvent.length > 0 &&
      addPinMarker.length > 0
    ) {
      setDisableState(false);
    } else {
      setDisableState(true);
    }
  }, [
    showErrorMsg,
    waringMsg,
    addSpecialEvent,
    addPinMarker,
    EventNameWaringMsg,
  ]);

  useEffect(() => {
    if (
      !showErrorMsg &&
      !waringMsg &&
      !EventNameWaringMsg &&
      editSpecialEvent.length > 0 &&
      editPinMarker.length > 0
    ) {
      setEditDisableState(false);
    } else {
      setEditDisableState(true);
    }
  }, [
    showErrorMsg,
    waringMsg,
    editSpecialEvent,
    editPinMarker,
    EventNameWaringMsg,
  ]);

  const editSpecialPinChange = (e) => {
    setActiveButton1(true);
    setEditSpecialEvent(e.target.value);
    let inputValue = e.target.value;
    // let lastStr = inputValue.charAt(inputValue.length - 1);
    let checkValid = filterSpecialPins.filter((item, index) => {
      if (item !== undefined) {
        let loopItem = item;
        let checkData = loopItem === inputValue.toUpperCase();
        return checkData;
      }
    });
    if (checkValid.length !== 0) {
      setEventNameWaringMsg(true);
    } else {
      setEventNameWaringMsg(false);
    }
  };
  const addSpecialPinChange = (e) => {
    setAddSpecialEvent(e.target.value);
    let inputValue = e.target.value;
    // let lastStr = inputValue.charAt(inputValue.length - 1);
    let checkValid = filterSpecialPins.filter((item, index) => {
      if (item !== undefined) {
        let loopItem = item;
        let checkData = loopItem === inputValue.toUpperCase();
        return checkData;
      }
    });
    if (checkValid.length !== 0) {
      setEventNameWaringMsg(true);
    } else {
      setEventNameWaringMsg(false);
    }

    if (
      !showErrorMsg &&
      !waringMsg &&
      addSpecialEvent.length > 0 &&
      addPinMarker.length > 0
    ) {
      setDisableState(false);
    } else {
      setDisableState(true);
    }
  };

  const checkDelete = (evt, rotationData, rotationIndex) => {
    setActiveButton(true);
    evt.preventDefault();
    let daily = evt.target.name === "Daily";
    let filteredArray = [];

    filteredArray = greensDescriptionsState.RotationSets.filter(
      (el) => el.Type === evt.target.name
    );
    logActionsState.push(
      `Remove rotation ${rotationData?.RotationNumber} of ${filteredArray[0].Rotations.length}`
    );

    // renderNewArray.length > 0
    //   ? setRenderNewArray(
    //       renderNewArray.filter((el) => el.Type === evt.target.name)
    //     )
    //   : [];

    let newFilteredArray = [];

    newFilteredArray = filteredArray[0]?.Rotations?.filter(
      (e, index) => index !== rotationIndex
    );

    // let updatedArray = greensDescriptionsState?.RotationSets[0]?.Rotations;

    newFilteredArray = newFilteredArray.map((data, index) => {
      return {
        ...data,
        Marker: (index + 1).toString(),
        RotationNumber: index + 1,
      };
    });

    if (daily) {
      const activeData = newFilteredArray?.find((data) => data.Active);
      greensDescriptionsState.RotationSets[0].CurrentRotation =
        activeData?.RotationNumber;
    }
    filteredArray[0].Rotations =
          newFilteredArray.flat(1);

    let newapproach = greensDescriptionsState?.ApproachViews?.map(
      (pin) => {
        pin.PinPlacements = pin.PinPlacements?.filter((idx) => idx.Name !== rotationData.Marker.toString());
        pin.PinPlacements.map((data, i) => {
          data.Name = (i + 1).toString();
          return data;
        })
        return pin;
      }
    );
    greensDescriptionsState.ApproachViews = newapproach;

    setGreensDescriptionsState(greensDescriptionsState);

    setUpdatedDom(!updateDom);
  };

  const addSpecialEventPin = (evt) => {
    setAddOpen(true);
  };
  const specialEdit = (evt, rotationData) => {
    setActiveButton(true);
    setOpen(true);
    setEditSpecialEvent(rotationData.DisplayName);
    setEditPinMarker(rotationData.Marker);
    let filterData = greensDescriptionsState.RotationSets.filter(
      (e) => e?.Name === rotationData?.DisplayName
    );
    setEditData(filterData);
  };
  const submitEditData = (e) => {
    e.preventDefault();
    if (
      !showErrorMsg &&
      !waringMsg &&
      editSpecialEvent.length > 0 &&
      editPinMarker.length > 0
    ) {
      let getFilterData = [...EditData];
      let newFilteredArray = greensDescriptionsState.RotationSets.filter(
        (e) => e?.Name !== getFilterData[0].Name
      );

      getFilterData[0].Name = editSpecialEvent;
      getFilterData[0].UserFigure = editPinMarker;
      getFilterData[0].Rotations[0].DisplayName = editSpecialEvent;
      getFilterData[0].Rotations[0].Marker = editPinMarker;
      newFilteredArray.push(getFilterData);
      greensDescriptionsState.RotationSets = newFilteredArray.flat(1);
      setGreensDescriptionsState(greensDescriptionsState);
      handleClose();
    }
  };
  const submitSpecialEventPinData = (e) => {
    e.preventDefault();
    if (
      !showErrorMsg &&
      !waringMsg &&
      !EventNameWaringMsg &&
      addSpecialEvent.length > 0 &&
      addPinMarker.length > 0
    ) {
      let newEventPin = {
        Course: courseId,
        CurrentRotation: 1,
        FirstHole: 1,
        IsActive: false,
        LastHole: 18,
        Name: addSpecialEvent,
        UserFigure: addPinMarker,
        RotationSetType: 2,
        Type: "Special",
        Rotations: [
          {
            Active: false,
            DisplayName: addSpecialEvent,
            Marker: addPinMarker,
            RotationNumber: 1,
            RotationType: 1,
          },
        ],
      };

      let tempData = greensDescriptionsState;
      tempData.RotationSets.push(newEventPin);
      setGreensDescriptionsState(tempData);
      handleAddClose();
      logActionsState.push(`Add rotation ${addPinMarker}`);
    }
  };

  const specialDelete = (evt, rotationData) => {
    setActiveButton(true);
    evt.preventDefault();

    let newFilteredArray = [];
    newFilteredArray = greensDescriptionsState.RotationSets.filter(
      (item) => item.Name !== rotationData?.DisplayName
    );
    let specialFiltered = newFilteredArray.flat(2);

    greensDescriptionsState.RotationSets = specialFiltered;

    setGreensDescriptionsState(greensDescriptionsState);
    logActionsState.push(`Remove rotation ${rotationData?.Marker}`);
    setUpdatedDom(!updateDom);
  };
  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST) {
    return <Loader />;
  }
  const addSpecialEvtCancelFunc = () => {
    setActiveButton(false);
    setActiveButton1(false);
    handleAddClose();
  };
  const editSpecialEvtCancelFunc = () => {
    setActiveButton(false);
    handleClose();
  };

  return (
    <Container>
      <DailyRotationDays />
      <Header>
        <HeaderBtn
          className={oneDayOverride ? "active" : ""}
          onClick={() => {
            if (oneDayOverride) {
              updateRemoveOpenOneDayState(true); // Open the second modal (deactivation)
            } else {
              updateAddOpenOneDayState(true); // Open the first modal (activation)
            }
          }}
          style={
            getFeatureSetOption(
              siteSettingsData?.Features,
              getFeaturesList().real_time_tracking
            )
              ? {
                backgroundColor: "#d3d3d3",
                cursor: "no-drop",
              }
              : {}
          }
          disabled={
            (getFeatureSetOption(
              siteSettingsData && siteSettingsData?.Features,
              getFeaturesList().real_time_tracking
            ) &&
              getUserRole &&
              getUserRole.Role !== 6) ||
            isUserBasic(getUserRole && getUserRole?.Role) ||
            isUserReadOnly(getUserRole && getUserRole?.Role)
          }
        >
          <SunIcon color="#fff" />
          {t("One-Day_Override")}
        </HeaderBtn>
        {/* <div className="container">
          <FormWraper className="ground-select">
            <FormControl>
              <Select
                native
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                variant="outlined"
                value={courseId}
                onChange={handleCourseName}
                // IconComponent={() => (
                //   <div style={{ padding: "0 5px", display: "flex" }}>
                //     <SelectArrow />
                //   </div>
                // )}
              >
                {courseList &&
                courseList?.Courses &&
                courseList?.Courses.length !== 0 ? (
                  courseList?.Courses.map((item, index) => (
                    <option key={item?.Name} value={item?.Number}>
                      {item?.Name}
                    </option>
                  ))
                ) : (
                  <option value=""></option>
                )}
              </Select>
            </FormControl>
          </FormWraper>
        </div> */}
      </Header>

      <BodyWrapper>
        <div>
          <Heading>{t("Daily_Pin_Placements")}</Heading>
          <CircleBtn
            disabled={
              isUserBasic(getUserRole && getUserRole?.Role) ||
              isUserReadOnly(getUserRole && getUserRole?.Role)
            }
            className="circle-btn"
            name="Daily"
            onClick={(evt) => addRotationSet(evt)}
          >
            <AddIcon />
            {t("Add_Daily_Pin_Rotation")}
          </CircleBtn>
          <BoxWrapper>
            {greensDescriptionsState &&
              Object.keys(greensDescriptionsState).length !== 0 &&
              greensDescriptionsState?.RotationSets &&
              greensDescriptionsState?.RotationSets.length !== 0 ? (
              greensDescriptionsState?.RotationSets.map((item, index) => (
                <React.Fragment key={index}>
                  {item?.Type === "Daily" && item?.Rotations?.length !== 0 ? (
                    item?.Rotations.map((rotationData, rotationIndex) => {
                      return (
                        <Tooltip key={rotationIndex} title={rotationData?.Active ? t("Can_not_delete"):""} placement="right">
                          <DataBox key={rotationIndex}>
                            <div>
                              <p>{t("Daily_Pin_Rotation")} {rotationIndex + 1}</p>
                              <p>
                                <span>
                                  {rotationData?.Active ? `(Active)` : ""}
                                </span>
                              </p>
                            </div>
                            <IconButton
                              key={rotationIndex}
                              name="Daily"
                              title={t("Delete")}
                              className="delete-icon-btn"
                              disabled={
                                rotationData?.Active ||
                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                isUserReadOnly(getUserRole && getUserRole?.Role)
                              }
                              onClick={
                                (evt) =>
                                  checkDelete(evt, rotationData, rotationIndex)
                              }
                            >
                              <DeleteIcon key={rotationIndex} width="18px" height="20px" />
                            </IconButton>
                          </DataBox>
                        </Tooltip>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </React.Fragment>
              ))
            ) : (
              <>{t("No_data")}</>
            )}
          </BoxWrapper>
        </div>
        <div>
          <Heading>{t("Special_Event_Pins")}</Heading>
          <CircleBtn
            disabled={
              isUserBasic(getUserRole && getUserRole?.Role) ||
              isUserReadOnly(getUserRole && getUserRole?.Role)
            }
            className="circle-btn"
            name="Special"
            onClick={handleAddOpen}
          >
            <AddIcon />
            {t("Add_Special_Event_Pin_Rotation")}
          </CircleBtn>
          <Modal
            open={addOpen}
            onClose={handleAddClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <PopUpContainer>
                <form action="" onSubmit={submitSpecialEventPinData}>
                  <h2 className="header"> {t("Add_Special_Event_Pin_Rotation")}</h2>
                  <div className="modal-body">
                    <div className="input-wrapper">
                      <p>{t("Special_Event_Name")}</p>
                      <input
                        type="text"
                        value={addSpecialEvent}
                        onChange={(e) => addSpecialPinChange(e)}
                      />
                      {EventNameWaringMsg ? (
                        <Alert severity="warning">
                          <AlertTitle>{t("Warning")}</AlertTitle>
                          {t(
                            "Selected_name_is_already_in_use.__Pin_Placement_Name_must_be_unique."
                          )}
                        </Alert>
                      ) : null}
                      <p className="des">{t("Enter_a_unique_description.")}</p>
                    </div>
                    <div className="input-wrapper">
                      <p>{t("Pin_Marker")}</p>
                      <input
                        type="text"
                        maxlength="2"
                        value={addPinMarker}
                        onChange={(e) => {
                          addPinMarkerChange(e);
                        }}
                      />

                      {waringMsg ? (
                        <Alert severity="warning">
                          <AlertTitle>{t("Warning")}</AlertTitle>
                          {("Selected_letter_is_already_in_use.__Pin_Marker_must_be_unique.")}
                        </Alert>
                      ) : null}
                      {showErrorMsg ? (
                        <Alert severity="error">
                          <AlertTitle>{t("Error")}</AlertTitle>
                          Markers for special events must be a letter from A to
                          Z.
                        </Alert>
                      ) : null}
                      <p className="des">{t("Letters_A-Z_may_be_chosen")}.</p>
                    </div>
                  </div>
                  <div className="action-btn">
                    <Button title={t("Cancel")} onClick={addSpecialEvtCancelFunc}>
                      {t("Cancel")}
                    </Button>
                    <Button
                      variant="outlined"
                      className={!disableState ? "active" : "disabled"}
                      title={t("Add")}
                      disabled={disableState}
                      type="submit"
                    >
                      {t("Add")}
                    </Button>
                  </div>
                </form>
              </PopUpContainer>
            </Box>
          </Modal>
          <BoxWrapper>
            <>
              {greensDescriptionsState &&
                Object.keys(greensDescriptionsState).length !== 0 &&
                greensDescriptionsState?.RotationSets &&
                greensDescriptionsState?.RotationSets.length !== 0 ? (
                greensDescriptionsState?.RotationSets.map((item) => (
                  <React.Fragment key={uuid()}>
                    {item?.Type === "Special" &&
                      item?.Rotations &&
                      item?.Rotations.length !== 0 ? (
                      item?.Rotations.map((rotationData, rotationIndex) => (
                        <DataBox key={uuid()}>
                          <div>
                            <p>{rotationData?.DisplayName}</p>
                            <p>
                              {rotationData?.Marker}{" "}
                              <span>
                                {rotationData?.Active ? `(Active)` : ""}
                              </span>
                            </p>
                          </div>
                          <button
                            className="delete-icon-btn"
                            title="Edit special pin"
                            onClick={(evt) => specialEdit(evt, rotationData)}
                          >
                            <EditIcon
                              width={18}
                              height={18}
                              color="var(--theme-background)"
                            />
                          </button>
                          <IconButton
                            name="Special"
                            className="delete-icon-btn"
                            title="Delete special pin"
                            disabled={
                              rotationData?.Active ||
                              isUserBasic(getUserRole && getUserRole?.Role) ||
                              isUserReadOnly(getUserRole && getUserRole?.Role)
                            }
                            onClick={
                              (evt) => specialDelete(evt, rotationData)
                            }
                          >
                            <DeleteIcon width="18px" height="20px" />
                          </IconButton>
                        </DataBox>
                      ))
                    ) : (
                      <></>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <>{t("No_Data_Found")}</>
              )}
            </>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <PopUpContainer>
                  <form
                    action=""
                    onSubmit={submitEditData}
                  >
                    <h2 className="header">
                      {" "}
                      {t("Edit_Special_Event_Pin_Rotation")}
                    </h2>
                    <div className="modal-body">
                      <div className="input-wrapper">
                        <p>{t("Special_Event_Name")}</p>
                        <input
                          type="text"
                          value={editSpecialEvent}
                          onChange={(e) => editSpecialPinChange(e)}
                        />
                        {EventNameWaringMsg ? (
                          <Alert severity="warning">
                            <AlertTitle>{t("Warning")}</AlertTitle>
                            {t(
                              "Selected_name_is_already_in_use.__Pin_Placement_Name_must_be_unique."
                            )}
                          </Alert>
                        ) : null}
                        <p className="des">{t("Enter_a_unique_description.")}</p>
                      </div>
                      <div className="input-wrapper">
                        <p>{t("Pin_Marker")}</p>
                        <input
                          type="text"
                          maxlength="2"
                          value={editPinMarker}
                          onChange={(e) => {
                            editPinMarkerChange(e);
                          }}
                        />
                        {waringMsg ? (
                          <Alert severity="warning">
                            <AlertTitle>Warning</AlertTitle>
                            {t(
                              "Selected_letter_is_already_in_use.__Pin_Marker_must_be_unique."
                            )}
                          </Alert>
                        ) : null}
                        {showErrorMsg ? (
                          <Alert severity="error">
                            <AlertTitle>{t("Error")}</AlertTitle>
                            {t(
                              " Markers_for_special_events_must_be_a_letter_from_A_to_Z"
                            )}
                            .
                          </Alert>
                        ) : null}
                        <p className="des">{t("Letters_A-Z_may_be_chosen")}.</p>
                      </div>
                    </div>
                    <div className="action-btn">
                      <Button title={t("Cancel")} onClick={editSpecialEvtCancelFunc}>
                        {t("Cancel")}
                      </Button>
                      <Button
                        variant="outlined"
                        title={t("Save")}
                        disabled={editDisableState || !activeButton1}
                        type="submit"
                        className={
                          !editDisableState || activeButton1
                            ? "active"
                            : "disabled"
                        }
                      >
                        {t("Save")}
                      </Button>
                    </div>
                  </form>
                </PopUpContainer>
              </Box>
            </Modal>
          </BoxWrapper>
        </div>
      </BodyWrapper>
      <ActionBtn>
        <Button
          variant="outlined"
          disabled={
            isUserBasic(getUserRole && getUserRole?.Role) ||
            isUserReadOnly(getUserRole && getUserRole?.Role)
          }
          title={t("Cancel")}
          onClick={() => setConfirmMsg(true)}
          className={activeButton ? "" : "disabled"}
        >
          {/* <CloseIcon width={20} height={20} color={activeButton ? "#000000" : "#00000042"}
          /> */}
          {t("Cancel")}
        </Button>
        <Button
          variant="outlined"
          disabled={
            isUserBasic(getUserRole && getUserRole?.Role) ||
            isUserReadOnly(getUserRole && getUserRole?.Role)
          }
          title={t("Save")}
          onClick={saveData}
          className={activeButton ? "active" : "disabled"}
        >
          {/* <SaveChangeIcon
          color={activeButton ? "#fff" : "#00000042"}
          /> */}
          {t("Save")}
        </Button>
      </ActionBtn>
      <Modal
        open={sucessMsg}
        onClose={() => setSucessMsg(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>Changes saved Successfully</p>
            <div className="action-btn">
              <button
                className="primary"
                title={t("Ok")}
                onClick={() => setSucessMsg(false)}
              >
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>    
      <Modal
        open={confirmMsg}
        onClose={() => setConfirmMsg(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Discard_changes")}?</p>
            <div className="action-btn">
              <button className="primary" title="Yes" onClick={discardFunc}>
                {t("Yes")}
              </button>
              <button title="No" onClick={() => setConfirmMsg(false)}>
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>

      <Modal
        open={addOpenOneDay}
        onClose={() => updateAddOpenOneDayState(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Add_One-day_override_pins?")}</p>
            <div className="action-btn">
              <button className="primary" title="Yes" onClick={addOneDayOr}>
                {t("Yes")}
              </button>
              <button title="No" onClick={() => setAddOpenOneDay(false)}>
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={removeOpenOneDay}
        onClose={() => updateRemoveOpenOneDayState(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Remove_the_One-day_override_pins?")}</p>
            <div className="action-btn">
              <button className="primary" title="Yes" onClick={removeOneDayOr}>
                {t("Yes")}
              </button>
              <button title="No" onClick={() => setRemoveOpenOneDay(false)}>
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </Container>
  );
};